// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-landing-page -> case-associates-lp-landing-page -> high-ridge-apts
// Generated: 2026-08-27T21:38:01.724Z
// Counts: 9 design, 13 content, 8 slot group, 2 collection binding, 2 section, 0 style

export const designOverrides = {
  "design._site.color.secondary": {
    "cssVariable": "--vibe-color-secondary",
    "overrideType": "VALUE",
    "value": "#222222",
    "mappedField": null
  },
  "design._site.color.surface": {
    "cssVariable": "--vibe-color-surface",
    "overrideType": "VALUE",
    "value": "#222222",
    "mappedField": null
  },
  "design._site.color.textOnPrimary": {
    "cssVariable": "--vibe-color-text-on-primary",
    "overrideType": "VALUE",
    "value": "#ffffff",
    "mappedField": null
  },
  "design._site.color.textOnSecondary": {
    "cssVariable": "--vibe-color-text-on-secondary",
    "overrideType": "VALUE",
    "value": "#ffffff",
    "mappedField": null
  },
  "design._site.font.accent": {
    "cssVariable": "--vibe-font-accent",
    "overrideType": "VALUE",
    "value": "'Poppins', sans-serif",
    "mappedField": null
  },
  "design._site.font.body": {
    "cssVariable": "--vibe-font-body",
    "overrideType": "VALUE",
    "value": "'Poppins', sans-serif",
    "mappedField": null
  },
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Poppins', sans-serif",
    "mappedField": null
  },
  "design._site.font.mono": {
    "cssVariable": "--vibe-font-mono",
    "overrideType": "VALUE",
    "value": "'Poppins', sans-serif",
    "mappedField": null
  },
  "design.NeighborhoodMap.color.surface": {
    "cssVariable": "--vibe-color-surface",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_secondary_color"
  }
};

export const contentOverrides = {
  "header.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_ppc_tracking_phone_number"
  },
  "hero.form.bedroom_list_type": {
    "overrideType": "VALUE",
    "customValue": "derived",
    "generatedValue": null,
    "mappedField": null
  },
  "multihub-lead-capture.lead_source": {
    "overrideType": "VALUE",
    "customValue": "LANDING_PAGE",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=320/company/5767906449162419/019d44e1-ffea-77f5-9b99-ca8ffce103d2.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_ppc_tracking_phone_number"
  },
  "footer.accessibility_link": {
    "overrideType": "VALUE",
    "customValue": "<p><a target=\"_blank\" rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/accessibility-statement/\">Accessibility</a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_ppc_tracking_phone_number"
  },
  "footer.privacy_link": {
    "overrideType": "VALUE",
    "customValue": "<p><a target=\"_blank\" rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/privacy-policy/\">Privacy Policy</a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "hero.form.captcha_enabled": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.form.form_header_text": {
    "overrideType": "VALUE",
    "customValue": "Contact Us",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_ppc_tracking_phone_number"
  }
};

export const slotGroupOverrides = {
  "header.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "query_params": {
        "type": "VALUE",
        "customValue": "?utm_medium=ppc&utm_source=google&utm_campaign=landing-page"
      }
    }
  },
  "hero.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "query_params": {
        "type": "VALUE",
        "customValue": "?utm_medium=ppc&utm_source=google&utm_campaign=landing-page"
      }
    }
  },
  "footer.legal_link_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://www.caseusa.com/privacy-policy/"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "footer.legal_link_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://www.caseusa.com/accessibility-statement/"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "propertyoverview.gallery_0": {
    "sourceIndex": 35,
    "fieldOverrides": null
  },
  "submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "thankyouhero.visit_website_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "query_params": {
        "type": "VALUE",
        "customValue": "?utm_medium=ppc&utm_source=google&utm_campaign=landing-page"
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "neighborhoodmap.pois": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
